import React, { useState } from 'react';

interface ToggleSwitchProps {
    toggleName: string;
    isOn: boolean;
    handleToggle: () => void;
    onColor?: string;
    offColor?: string;
    label?: string;
    disabled?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ toggleName, isOn, handleToggle, onColor = "#3d948d", offColor = '#939393', label, disabled}) => {
    return (
        <div className="toggle-switch">
            <input
                className="toggle-switch-checkbox"
                id={toggleName}
                type="checkbox"
                checked={isOn}
                onChange={handleToggle}
                disabled={disabled}
            />
            <label
                className="toggle-switch-label"
                htmlFor={toggleName}
                style={{ background: isOn ? onColor : offColor, borderColor: isOn ? onColor : offColor }}
            >
                <span className={`toggle-switch-button`} >
                    {isOn ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px" style={{ fill: isOn ? onColor : offColor}}>
                            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px" style={{ fill: isOn ? onColor : offColor}}>
                            <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
                        </svg>
                    )}
                </span>

                {label && <span className="toggle-switch-label-text">{label}</span>}
            </label>

        </div>
    );
};

export default ToggleSwitch;
